export enum NoteConstants {
  newNoteLimit = 3000,
}
